import Settings from '../../../templates/views/Settings';

export default {
  path: 'settings',
  component: Settings,
  name: 'Settings',
  meta: {
    title: t => t('screens.settingsScreen', 'app_mobile'),
    loggedInOnly: true
  },
};

